import Langs from './langs';

export default Langs;